//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Represents the approval status of a note */
export const NoteApprovalStatus = {
    /** The Note is pending approval. */
    PendingApproval: 0,

    /** The Note has been approved. */
    Approved: 1,

    /** The Note was denied. */
    Denied: 2
} as const;

/** Represents the approval status of a note */
export const NoteApprovalStatusDescription: Record<number, string> = {
    0: "Pending Approval",

    1: "Approved",

    2: "Denied"
};

/** Represents the approval status of a note */
export type NoteApprovalStatus = typeof NoteApprovalStatus[keyof typeof NoteApprovalStatus];
